// extracted by mini-css-extract-plugin
module.exports = {"socials":"SocialLinks_socials__3U6Ct","facebook":"SocialLinks_facebook__D-oiJ","twitter":"SocialLinks_twitter__n_KTZ","linkedin":"SocialLinks_linkedin__3GKsm"};